import React, { useEffect, useState } from 'react';
import './PermitCertificate.css';
import govtLogo from '../assets/icons/StateemblemofPakistan.svg';
import { handleGetRequest } from '../services/GetTemplate';
import backImg from '../assets/icons/State_emblem_of_Pakistan.svg1.svg';

const PermitCertificate = React.forwardRef(({ data }, ref) => {
    const [permitData, setPermitData] = useState([]);

    useEffect(() => {
        getpermitdata();
    }, [data]);

    const getpermitdata = async () => {
        const response = await handleGetRequest(`/api/permit/${data?.id}`);
        if (response?.success) {
            setPermitData(response.data[0]);
        }
    };

    const calculateExpiryDate = (registrationDate) => {
        if (!registrationDate) return '';
        const regDate = new Date(registrationDate);
        const expiryDate = new Date(regDate);
        expiryDate.setDate(regDate.getDate() + 60);
        return expiryDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <div ref={ref} className="permit-certificate" style={{ backgroundImage: `url(${backImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="certificate-header">
                <img src={govtLogo} alt="Logo" className="logo" />
                <div className="header-text">
                    <h1>GOVERNMENT OF PAKISTAN OFFICE OF</h1>
                    <h2>THE SECRETARY ISLAMABAD TRANSPORT</h2>
                    <h2>AUTHORITY ICT, ISLAMABAD</h2>
                </div>
                <div className="header-space"></div>
            </div>

            <h3 className="certificate-title">CONTRACT CARRIAGE ROUTE PERMITS CERTIFICATE</h3>

            <div className="permit-info">
                <div className="permit-row header-row">
                    <div className="permit-cell">
                        <span className="permit-label">Permit No.</span>
                        <span>{data?.id || ''}</span>
                    </div>
                    <div className="permit-cell text-right">
                        <span className="permit-label">Dated: {new Date().toLocaleDateString('en-GB')}</span>
                    </div>
                </div>

                <table className="permit-table">
                    <tbody>
                        <tr>
                            <td className="label">Applicant Name</td>
                            <td className="value">{permitData?.name || ''}</td>
                        </tr>
                        <tr>
                            <td className="label">Address</td>
                            <td className="value">{permitData?.address || ''}</td>
                        </tr>
                        <tr>
                            <td className="label">Vehicle Category</td>
                            <td className="value">{permitData?.vehicleTypeName || ''}</td>
                        </tr>
                        <tr>
                            <td className="label">Model</td>
                            <td className="value">{permitData?.model || ''}</td>
                        </tr>
                        <tr>
                            <td className="label">Registration No.</td>
                            <td className="value">{permitData?.registerationNumber || ''}</td>
                        </tr>
                        <tr>
                            <td className="label">Route No.</td>
                            <td className="value">133</td>
                        </tr>
                        <tr>
                            <td className="label">Route Alignment</td>
                            <td className="value">Pirwadhai to Chowara via (101-2, Police Line G-11/4 Katarian, G-11/1, F-11/1-2 and Shah Dara Chowara</td>
                        </tr>
                        <tr>
                            <td className="label">Permit Expiry Date</td>
                            <td className="value">{calculateExpiryDate(permitData?.registrationDate)}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="note-section">
                    <table className="note-table">
                        <tbody>
                            <tr>
                                <td className="label">Note:</td>
                                <td className="value">
                                    <ol>
                                        <li>Maximum number of passenger as per registration book.</li>
                                        <li>Renew your route permit at least one month before expiry date</li>
                                        <li>If permit is not renewed within due date, a fine of Rs.300 will be charged</li>
                                    </ol>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="signature-section">
                    <div className="signature">
                        <p>Secretary Islamabad</p>
                        <p>Transport Authority ICT,</p>
                        <p>Islamabad</p>
                    </div>
                </div>
                <div className="signature-section mt-8">
                    <div className="signature">
                        <p>Secretary Islamabad</p>
                        <p>Transport Authority ICT,</p>
                        <p>Islamabad</p>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PermitCertificate;
